/* eslint-disable */
import React, { Children, cloneElement } from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'

const StyledUl = styled('ul')`
  height: 100%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  list-style-type: none;
  margin: 0;
  padding: 0 16px;
`

const NavList = ({ children, location }) => (
  <StyledUl>
    {Children.map(children, child => cloneElement(child, { location }))}
  </StyledUl>
)

NavList.defaultProps = {
  location: {},
};

NavList.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  location: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
}

export default NavList
